import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router';
import { paths } from '../../../../common/constants/pathVariables.js';
import { SubscriptionCategory } from '../../../../common/enums';
import { t } from '../../../../common/i18n/index.js';
import { deepEqual } from '../../../../common/utils/objectUtils.js';
import { EoeHomeScene } from '../../../../components/EoeHomeScene/EoeHomeScene.js';
import { getEmployeeSubscriptions, loadVirtualCatalogs } from '../../../../selfservice/actions/index.js';
import { useAuth } from '../../AuthProvider.js';
import type { State } from '../../../../selfservice/common/store.js';

export const EoeHomePath = () => {
  const dispatch = useDispatch();
  const { authenticatedUser } = useAuth();

  const isLinkedWithAccount = Boolean(authenticatedUser?.businessId);

  const selfService = useSelector((state: State) => state.selfservice, deepEqual);
  const subscriptions = useSelector((state: State) => state.user?.authenticated?.subscriptions, deepEqual);
  const subscriptionActions = selfService?.pendingSubscriptionActions?.items || [];

  useEffect(() => {
    if (authenticatedUser?.businessId) {
      dispatch(loadVirtualCatalogs());
      dispatch(getEmployeeSubscriptions(SubscriptionCategory.DEVICE));
      dispatch(getEmployeeSubscriptions(SubscriptionCategory.BROADBAND));
      dispatch(getEmployeeSubscriptions(SubscriptionCategory.VOICE));
    }
  }, [dispatch, authenticatedUser?.businessId, authenticatedUser?.contact?.person?.roles]);

  return (
    <>
      <EoeHomeScene subscriptions={subscriptions} subscriptionActions={subscriptionActions} />
      {!isLinkedWithAccount && (
        <div className="of-employee__guide-notification-container">
          <div className="ea-context-notification">
            <div className="ea-context-notification__text">
              <h4 className="ea-h4">{t.I2YS('Important information')}</h4>
              {t.T58Y('Your profile is not associated with any company or business yet. You can either ')}
              <Link to={paths.EMPLOYEE_SUBSCRIPTIONS} rel="noopener noreferrer">
                {t.PDYE('link a company provided subscription ')}
              </Link>
              {t.TQFU('or ask for invitation link from your company admin to sign up to this portal.')}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
